module.exports = __webpack_public_path__ + "static/media/spasmo.1a27d407.jpeg";